import { useDef } from '@app/router';
import { Route, Switch } from '@wikom/wikom-router';
import React from 'react';
import AccessDenied from './pages/AccessDenied';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import About from './pages/About';
import Datenschutz from './pages/Datenschutz';
import Facts from './pages/Facts';
import Faq from './pages/Faq';
import Forms from './pages/Forms';
import Requirements from './pages/Requirements';
import Terms from './pages/Terms';
import Wartung from './pages/Wartung';
import EmailLwk from './pages/EmailLwk';
var Common = function () {
    var _a = useDef().PAGE, COMMON = _a.COMMON, NOT_FOUND = _a.NOT_FOUND;
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: COMMON.EMAIL_LWK },
            React.createElement(EmailLwk, null)),
        React.createElement(Route, { path: COMMON.ACCESS_DENIED },
            React.createElement(AccessDenied, null)),
        React.createElement(Route, { path: COMMON.WARTUNG },
            React.createElement(Wartung, null)),
        React.createElement(Route, { path: COMMON.CONTACT },
            React.createElement(Contact, null)),
        React.createElement(Route, { path: COMMON.ABOUT },
            React.createElement(About, null)),
        React.createElement(Route, { path: COMMON.DATENSCHUTZ },
            React.createElement(Datenschutz, null)),
        React.createElement(Route, { path: COMMON.FACTS },
            React.createElement(Facts, null)),
        React.createElement(Route, { path: COMMON.FAQ },
            React.createElement(Faq, null)),
        React.createElement(Route, { path: COMMON.FORMS },
            React.createElement(Forms, null)),
        React.createElement(Route, { path: COMMON.REQUIREMENTS },
            React.createElement(Requirements, null)),
        React.createElement(Route, { path: COMMON.TERMS },
            React.createElement(Terms, null)),
        React.createElement(Route, { path: "*" },
            React.createElement(NotFound, null))));
};
export default Common;
